import { Box, Tab, Tabs } from "@mui/material";
import * as React from "react";
import { Link, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { useLanguage } from "../../Language";
import { useLocationConfiguration } from "../../LocationConfiguration";
import { useMemo } from "react";
import { useScrollToTop } from "@tlc/ui/ScrollToTop";

export const AdvancedSearchPage: React.FC = () => {
  const { translate } = useLanguage();
  const { pathname } = useLocation();
  const { locationConfiguration: { pacSettings } = { pacSettings: null } } =
    useLocationConfiguration();

  const [params] = useSearchParams();
  const page = params.get("page");
  const prevPathnameRef = React.useRef<string>(pathname);

  const [scrollCallbackRef, scrollToTop] = useScrollToTop();

  // runs on every page change
  React.useEffect(() => {
    if (prevPathnameRef.current === pathname) {
      scrollToTop();
    }
    prevPathnameRef.current = pathname;
  }, [page, pathname]);

  // TODO I'm beginning to feel pretty strongly that boolean and reading level searches should just be merged into a single page/form
  // boolean vs. readingLevel is more a toggle for the same advanced search endpoint
  // Instead of tabs we could use a toggle button and a link to Reserves
  const displayTabs = useMemo(() => {
    if (pathname.includes("results")) return false;
    return true;
  }, [pathname]);

  return (
    <>
      {displayTabs && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Tabs
            value={pathname}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="scrollable auto tabs example"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab
              value="/advanced-search/boolean"
              component={Link}
              to="boolean"
              label={translate("booleanSearch")}
            ></Tab>
            {(pacSettings?.acceleratedReaderEnabled ||
              pacSettings?.lexileEnabled) && (
              <Tab
                value="/advanced-search/reading-levels"
                component={Link}
                to="reading-levels"
                label={translate("readingLevels")}
              ></Tab>
            )}
            {pacSettings?.reservesEnabled && (
              <Tab
                value="/reserves"
                component={Link}
                to="/reserves"
                label={translate("academicReserves")}
              ></Tab>
            )}
          </Tabs>
        </Box>
      )}
      <Box
        ref={scrollCallbackRef}
        sx={{
          padding: 2,
        }}
      >
        <Outlet></Outlet>
      </Box>
    </>
  );
};
